import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LinuxOutlinedSvg from "@ant-design/icons-svg/es/asn/LinuxOutlined";
import AntdIcon from '../components/AntdIcon';
var LinuxOutlined = function LinuxOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: LinuxOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(LinuxOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'LinuxOutlined';
}
export default RefIcon;